import { render, staticRenderFns } from "./CheckedEmailInstitutionContact.vue?vue&type=template&id=0806df70&"
import script from "./CheckedEmailInstitutionContact.vue?vue&type=script&lang=js&"
export * from "./CheckedEmailInstitutionContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports